import sendRequest from "@/libs/sendRequest"

const local_guides = {
    namespaced: true,
    state: {
        local_guide: {},
        local_guides: [],
        local_guide_id: 0,
        local_guide_reviews: [],
        error: false,
        last_page: null,
        total_pages: null
    },
    getters: {
        getLocalGuideReviews: (state) => (state.local_guide_reviews),
        getLocalGuide: (state) => (state.local_guide),
        getLocalGuides: (state) => (state.local_guides),
        getLocalGuideId:(state) => (state.local_guide_id),
        getLastPage: (state) => (state.last_page),
        getTotalPages: (state) => (state.total_pages),
        getError: (state) => (state.error)
    },
    mutations: {
        setLocalGuide: (state, payload) => state.local_guide = payload,
        setLocalGuides: (state, payload) => state.local_guides = payload,
        setLocalGuideId: (state, payload) => state.local_guide_id = payload,
        setLocalGuideReviews: (state, payload) => state.local_guide_reviews = payload,
        setLastPage: (state, payload) => state.last_page = payload,
        setTotalPages: (state, payload) => state.total_pages = payload,
        setError: (state, payload) => state.error = payload,
    },
    actions: {
        list: async({commit, dispatch, rootGetters}, query) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/users/local_guides/list', 'GET', null, query, custom_headers)

            if(response.success && response.data) {
                if(query.datatable) {
                    commit('setLocalGuides', response.data.list.result ?? [])
                    commit('setTotalPages', response.data.list.total_pages)

                    if(response.data.list.total_pages == query.page) {
                        commit('setLastPage', true)
                    }
                    else {
                        commit('setLastPage', false)
                    }
                }
                else {
                    commit('setLocalGuides', response.data.list)
                }
                dispatch('hiddenLoading', null, { root: true })
            }
            else if(!response.success && response.errors) {
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', 'An error has occurred try later', { root: true })
            }
            else if(!response.success && !response.data) {
                dispatch('lostConection', null, { root: true })
            }
        },
        view: async({commit, dispatch, rootGetters}, query) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/users/local_guides/view', 'GET', null, query, custom_headers)

            if(response.success && response.data) {
                commit('setLocalGuide', response.data.view)
                dispatch('hiddenLoading', null, { root: true })
            }
            else if(!response.success && response.errors) {
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', 'An error has occurred try later', { root: true })
            }
            else if(!response.success && !response.data) {
                dispatch('lostConection', null, { root: true })
            }
        },
        createLocalGuide: async({commit, dispatch, rootGetters}, payload) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/users/local_guides/create_localguide', 'PUT', payload.body, payload.query, custom_headers)

            if(response.success && response.data) {
                dispatch('showAlert', 'Info saved successfully', { root: true })
                dispatch('hiddenLoading', null, { root: true })
                commit('setLocalGuideId', response.data.id)
                commit('setError', false)
            }
            else if(!response.success && response.errors) {
                let messages = []
                for(let error in response.errors) {
                    switch(response.errors[error].code) {
                        case 'error_empty_id_city':
                            messages.push('Error: city required.')
                            break;
                        case 'error_empty_first_name':
                            messages.push('Error: first name required.')
                            break;
                        case 'error_empty_last_name':
                            messages.push('Error: last name.')
                            break;
                        case 'error_empty_picture':
                            messages.push('Error: picture required.')
                            break;
                        case 'error_empty_languages':
                            messages.push('Error: languages required.')
                            break;
                        default:
                            messages.push('An error has occurred try later')
                            break
                    }
                }
                commit('setError', true)
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', messages, { root: true })
            }
            else if(!response.success && !response.data) {
                dispatch('lostConection', null, { root: true })
            }
        },
        addAccess: async({commit, dispatch, rootGetters}, data) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/users/local_guides/update_localguide_access', 'PUT', data.body, data.query, custom_headers)

            if(response.success && response.data) {
                dispatch('showAlert', 'Info saved successfully', { root: true })
                dispatch('hiddenLoading', null, { root: true })
                commit('setError', false)
            }
            else if(!response.success && response.errors) {
                let messages = []
                for(let error in response.errors) {
                    switch(response.errors[error].code) {
                        case 'error_empty_id_local_guide':
                            messages.push('Error: Local guide not found. Please save General tab first.')
                            break
                        case 'error_empty_email':
                            messages.push('Error: Email required.')
                            break
                        case 'error_empty_phone':
                            messages.push('Error: Phone number required.')
                            break
                        case 'error_empty_phone_with_coutry_code':
                            messages.push('Error: Please enter a valid phone number with country code.')
                            break
                        case 'error_empty_password':
                            messages.push('Error: Password required.')
                            break
                        case 'error_empty_confirm_password':
                            messages.push('Error: Confirm password required.')
                            break
                        case 'error_passwords_not_match':
                            messages.push('Error: Passwords must match.')
                            break
                        case 'error_local_guide_phone_has_already_exist':
                            messages.push('Error: This phone number is already registered.')
                            break
                        case 'error_local_guide_email_has_already_exist':
                            messages.push('Error: This email address is already registered.')
                            break
                        case 'error_local_guide_not_found':
                            messages.push('Error: Local guide not found.')
                            break
                        case 'error_local_guide_inactive':
                            messages.push('Error: Local guide is inactive.')
                            break
                        default:
                            messages.push('An error has occurred try later')
                            break
                    }
                }
                commit('setError', true)
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', messages, { root: true })
            }
            else if(!response.success && !response.data) {
                dispatch('lostConection', null, { root: true })
            }
        },
        addVehicle: async({commit, dispatch, rootGetters}, data) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/users/local_guides/update_localguide_vehicle', 'PUT', data.body, data.query, custom_headers)

            if(response.success && response.data) {
                dispatch('showAlert', 'Info saved successfully', { root: true })
                dispatch('hiddenLoading', null, { root: true })
                commit('setError', false)
            }
            else if(!response.success && response.errors) {
                let messages = []
                for(let error in response.errors) {
                    switch(response.errors[error].code) {
                        case 'error_empty_id_vehicle_model':
                            messages.push('Error: Model required')
                            break
                        case 'error_empty_id_color':
                            messages.push('Error: vehicle color required')
                            break
                        case 'error_empty_year':
                            messages.push('Error: vehicle year required')
                            break
                        default:
                            messages.push('An error has occurred try later')
                            break
                    }
                }
                commit('setError', true)
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', messages, { root: true })
            }
            else if(!response.success && !response.data) {
                dispatch('lostConection', null, { root: true })
            }
        },
        addFinances: async({commit, dispatch, rootGetters}, data) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/users/local_guides/update_localguide_finance', 'PUT', data.body, data.query, custom_headers)

            if(response.success && response.data) {
                dispatch('showAlert', 'Info saved successfully', { root: true })
                dispatch('hiddenLoading', null, { root: true })
                commit('setError', false)
            }
            else if(!response.success && response.errors) {
                let messages = []
                for(let error in response.errors) {
                    switch(response.errors[error].code) {
                        case 'error_empty_id_bank':
                            messages.push('Error: Bank required.')
                            break
                        case 'error_empty_code':
                            messages.push('Error: Interbank code required.')
                            break
                        default:
                            messages.push('An error has occurred try later')
                            break
                    }
                }
                commit('setError', true)
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', messages, { root: true })
            }
            else if(!response.success && !response.data) {
                dispatch('lostConection', null, { root: true })
            }
        },
        addDocuments: async({commit, dispatch, rootGetters}, data) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/users/local_guides/update_localguide_documents', 'PUT', data.body, data.query, custom_headers)

            if(response.success && response.data) {
                dispatch('showAlert', 'Info saved successfully', { root: true })
                dispatch('hiddenLoading', null, { root: true })
                commit('setError', false)
            }
            else if(!response.success && response.errors) {
                let messages = []
                for(let error in response.errors) {
                    switch(response.errors[error].code) {
                        case 'error_empty_id_local_guide':
                            messages.push('Error: Local guide ID missing.')
                            break
                        case 'error_empty_documents':
                            messages.push('Error: Documents required.')
                            break
                        case 'error_a_document_is_required':
                            messages.push('Error: A required document is missing.')
                            break
                        case 'error_empty_frontal_image':
                            messages.push('Error: Frontal image is required.')
                            break
                        case 'error_empty_reverse_image':
                            messages.push('Error: Reverse image is required.')
                            break
                        case 'error_empty_expiration':
                            messages.push('Error: Expiration date is required or has an invalid format.')
                            break
                        default:
                            messages.push('An error has occurred try later')
                            break
                    }
                }
                commit('setError', true)
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', messages, { root: true })
            }
            else if(!response.success && !response.data) {
                dispatch('lostConection', null, { root: true })
            }
        },
        listReviews: async({commit, dispatch, rootGetters}, query) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/users/local_guides/list_reviews', 'GET', null, query, custom_headers)

            if(response.success && response.data) {
                const list = response.data.list
                // Normalize: with datatable=false, model returns an array; with datatable=true, returns { result, total_pages }
                const reviews = Array.isArray(list) ? list : (list?.result ?? [])
                commit('setLocalGuideReviews', reviews)
                dispatch('hiddenLoading', null, { root: true })
                commit('setError', false)
            }
            else if(!response.success && response.errors) {
                let messages = []
                for(let error in response.errors) {
                    switch(response.errors[error].code) {
                        case 'error_empty_id_local_guide': messages.push('Error: local guide id missing.'); break
                        default: messages.push('An error has occurred, try later.'); break
                    }
                }
                commit('setError', true)
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', messages, { root: true })
            }
            else if(!response.success && !response.data) {
                dispatch('lostConection', null, { root: true })
            }
        },
        inactiveReview: async({commit, dispatch, rootGetters}, query) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/users/local_guides/inactive_review', 'DELETE', null, query, custom_headers)

            if(response.success && response.data) {
                dispatch('showAlert', 'Review removed successfully', { root: true })
                dispatch('hiddenLoading', null, { root: true })
                commit('setError', false)
            }
            else if(!response.success && response.errors) {
                let messages = []
                for(let error in response.errors) {
                    switch(response.errors[error].code) {
                        case 'error_empty_id_local_guide_review': messages.push('Error: review id missing.'); break
                        case 'error_review_not_found':             messages.push('Error: review not found.'); break
                        case 'error_inactive_local_guide_review':  messages.push('Error: could not remove review.'); break
                        default: messages.push('An error has occurred, try later.'); break
                    }
                }
                commit('setError', true)
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', messages, { root: true })
            }
            else if(!response.success && !response.data) {
                dispatch('lostConection', null, { root: true })
            }
        },
        updateVerified: async({commit, dispatch, rootGetters}, data) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/users/local_guides/update_localguide_verified', 'PUT', data.body, data.query, custom_headers)

            if(response.success && response.data) {
                dispatch('showAlert', data.body.verified ? 'Local guide marked as verified' : 'Local guide unmarked', { root: true })
                dispatch('hiddenLoading', null, { root: true })
                commit('setError', false)
            }
            else if(!response.success && response.errors) {
                let messages = []
                for(let error in response.errors) {
                    switch(response.errors[error].code) {
                        case 'error_empty_id_local_guide':           messages.push('Error: local guide id missing.'); break
                        case 'error_empty_verified':                 messages.push('Error: verified flag missing.'); break
                        case 'error_local_guide_not_found':          messages.push('Error: local guide not found.'); break
                        case 'error_local_guide_inactive':           messages.push('Error: local guide is inactive.'); break
                        case 'error_updating_local_guide_verified':  messages.push('Error: could not update verified flag.'); break
                        default: messages.push('An error has occurred, try later.'); break
                    }
                }
                commit('setError', true)
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', messages, { root: true })
            }
            else if(!response.success && !response.data) {
                dispatch('lostConection', null, { root: true })
            }
        },
        updateProfile: async({commit, dispatch, rootGetters}, data) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/users/local_guides/update_localguide_profile', 'PUT', data.body, data.query, custom_headers)

            if(response.success && response.data) {
                dispatch('showAlert', 'Profile updated successfully', { root: true })
                dispatch('hiddenLoading', null, { root: true })
                commit('setError', false)
            }
            else if(!response.success && response.errors) {
                let messages = []
                for(let error in response.errors) {
                    switch(response.errors[error].code) {
                        case 'error_empty_profile_fields':           messages.push('Error: at least one profile field is required.'); break
                        case 'error_empty_id_local_guide':           messages.push('Error: local guide id missing.'); break
                        case 'error_local_guide_not_found':          messages.push('Error: local guide not found.'); break
                        case 'error_local_guide_inactive':           messages.push('Error: local guide is inactive.'); break
                        case 'error_updating_local_guide_profile':   messages.push('Error: could not update profile.'); break
                        case 'error_inserting_local_guide_profile':  messages.push('Error: could not insert profile.'); break
                        default: messages.push('An error has occurred, try later.'); break
                    }
                }
                commit('setError', true)
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', messages, { root: true })
            }
            else if(!response.success && !response.data) {
                dispatch('lostConection', null, { root: true })
            }
        },
        updateSkills: async({commit, dispatch, rootGetters}, data) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/users/local_guides/update_localguide_skills', 'PUT', data.body, data.query, custom_headers)

            if(response.success && response.data) {
                dispatch('showAlert', 'Skills updated successfully', { root: true })
                dispatch('hiddenLoading', null, { root: true })
                commit('setError', false)
            }
            else if(!response.success && response.errors) {
                let messages = []
                for(let error in response.errors) {
                    switch(response.errors[error].code) {
                        case 'error_empty_skills':          messages.push('Error: at least one skill required.'); break
                        case 'error_invalid_skill_id':      messages.push('Error: invalid skill id.'); break
                        case 'error_skill_not_found':       messages.push('Error: one of the selected skills was not found.'); break
                        case 'error_local_guide_not_found': messages.push('Error: local guide not found.'); break
                        case 'error_local_guide_inactive':  messages.push('Error: local guide is inactive.'); break
                        default: messages.push('An error has occurred, try later.'); break
                    }
                }
                commit('setError', true)
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', messages, { root: true })
            }
            else if(!response.success && !response.data) {
                dispatch('lostConection', null, { root: true })
            }
        },
        updatePreferences: async({commit, dispatch, rootGetters}, data) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/users/local_guides/update_local_guide_preferences', 'PUT', data.body, data.query, custom_headers)

            if(response.success && response.data) {
                dispatch('showAlert', 'Preferences updated successfully', { root: true })
                dispatch('hiddenLoading', null, { root: true })
                commit('setError', false)
            }
            else if(!response.success && response.errors) {
                let messages = []
                for(let error in response.errors) {
                    switch(response.errors[error].code) {
                        case 'error_local_guide_not_found':  messages.push('Error: local guide not found.'); break
                        case 'error_local_guide_inactive':   messages.push('Error: local guide is inactive.'); break
                        default: messages.push('An error has occurred, try later.'); break
                    }
                }
                commit('setError', true)
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', messages, { root: true })
            }
            else if(!response.success && !response.data) {
                dispatch('lostConection', null, { root: true })
            }
        },
        delete: async({commit, dispatch, rootGetters}, id) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/users/local_guides/delete','DELETE', null, { id_local_guide: id }, custom_headers)

            if(response.success && response.data) {
                dispatch('showAlert', 'Local guide deleted successfully', { root: true })
                commit('setError', false)
            }
            else if(!response.success && response.errors) {
                commit('setError', true)
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', 'An error has ocurrec try again shortly', { root: true })
            }
            else if(!response.success && !response.data) {
                dispatch('lostConection', null, { root: true })
            }
        },
        updateExperienceCategory: async({commit, dispatch, rootGetters}, data) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/users/local_guides/update_localguide_experience_category', 'PUT', data.body, data.query, custom_headers)

            if(response.success && response.data) {
                dispatch('showAlert', 'Category updated successfully', { root: true })
                dispatch('hiddenLoading', null, { root: true })
                commit('setError', false)
            }
            else if(!response.success && response.errors) {
                let messages = []
                for(let error in response.errors) {
                    switch(response.errors[error].code) {
                        case 'error_empty_id_local_guide':          messages.push('Error: local guide id missing.'); break
                        case 'error_empty_id_experience_category':  messages.push('Error: category required.'); break
                        case 'error_local_guide_not_found':         messages.push('Error: local guide not found.'); break
                        case 'error_local_guide_inactive':          messages.push('Error: local guide is inactive.'); break
                        case 'error_experience_category_not_found': messages.push('Error: category not found.'); break
                        default: messages.push('An error has occurred, try later.'); break
                    }
                }
                commit('setError', true)
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', messages, { root: true })
            }
            else if(!response.success && !response.data) {
                dispatch('lostConection', null, { root: true })
            }
        },
        changePassword: async({commit, dispatch, rootGetters}, data) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders

            const response = await sendRequest('admin/users/local_guides/change_password','PUT', data.body, data.query, custom_headers)

            if(response.success && response.data) {
                dispatch('showAlert', 'Password changed sucessfully', { root: true })
                commit('setError', false)
            }
            else if(!response.success && response.errors) {
                let messages = []
                for(let error in response.errors) {
                    switch(response.errors[error].code) {
                        case 'error_empty_password':
                            messages.push('Error: new password required')
                            break
                        case 'error_empty_confirm_password':
                            messages.push('Error: confirm password required')
                            break
                        case 'error_passwords_not_match':
                            messages.push('Error: passwords doesn\'t match');
                            break
                        case 'error_traveller_access_not_found':
                            messages.push('Error: Can only change password to traveller with previous access data');
                            break
                        default:
                            messages.push('An error has ocurred, wait and try later')
                            break
                    }
                }
                commit('setError', true)
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', messages, { root: true })
            }
            else if(!response.success && !response.data) {
                dispatch('lostConection', null, { root: true })
            }
        }
    }
}

export default local_guides